import { render, staticRenderFns } from "./DetailPaymentRequest.vue?vue&type=template&id=2d6a3c52&scoped=true"
import script from "./DetailPaymentRequest.vue?vue&type=script&lang=ts"
export * from "./DetailPaymentRequest.vue?vue&type=script&lang=ts"
import style0 from "./DetailPaymentRequest.vue?vue&type=style&index=0&id=2d6a3c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6a3c52",
  null
  
)

export default component.exports